import React, { Component } from 'react'
import styled from 'styled-components'
import { XXLText } from './'

const ModalBackground = styled.div`
  display: ${props => (props.display ? 'block' : 'none')}; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
`

const Wrapper = styled.div`
  width: 100%;
  & > div {
    width: 100%;
  }
  #myImg {
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
    width: 100%;
    object-fit: contain;
  }

  #myImg:hover {
    opacity: 0.7;
  }

  /* Modal Content (image) */
  .modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
  }

  /* Caption of Modal Image */
  /*  #caption {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 150px;
  } */

  /* Add Animation */
  .modal-content,
  #caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
  }

  @-webkit-keyframes zoom {
    from {
      -webkit-transform: scale(0);
    }
    to {
      -webkit-transform: scale(1);
    }
  }

  @keyframes zoom {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }

  /* The Close Button */
  .close {
    color: #ddd;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
  }

  /* .close:hover,
  .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
  } */

  /* 100% Image Width on Smaller Screens */
  @media only screen and (max-width: 700px) {
    .modal-content {
      width: 100%;
    }
  }
`
const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #000;
  height: 60px;
  padding: 0 8px;
`

const ModalCover = styled.div`
  padding: 100px 0px;
`

class ImageModal extends Component {
  state = {
    showModal: false
  }
  render() {
    const { showModal } = this.state
    const { image, onTouchImage, onClose, caption = 'Product Image', height } = this.props
    return (
      <React.Fragment>
        <Wrapper>
          <div onClick={() => (onTouchImage ? onTouchImage() : null)}>
            <img
              id="myImg"
              src={image}
              alt="Snow"
              style={{ height: height }}
              onClick={() => this.setState({ showModal: true })}
            />
          </div>
          {showModal && (
            <ModalBackground id="myModal" className="modal" display={showModal}>
              <Header>
                <XXLText color="#fff">{caption}</XXLText>
                <div onClick={() => (onClose ? onClose() : null)}>
                  <div className="close" onClick={() => this.setState({ showModal: false })}>
                    &times;
                  </div>
                </div>
              </Header>
              <ModalCover>
                <img className="modal-content" id="img01" alt="image_alt" src={image} />
              </ModalCover>
            </ModalBackground>
          )}
        </Wrapper>
      </React.Fragment>
    )
  }
}

export default ImageModal



// WEBPACK FOOTER //
// ./src/components/ImageModal.js